import { Epic } from 'redux-observable';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';
import { pickAll } from 'ramda';
import { handlers } from '@alycecom/services';

import { IBranding, IBrandingParams, IBrandingColorParams } from '../../../types/Branding.types';

import {
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageFail,
  applyBrandingImages,
  updateBrandingRequest,
  updateBrandingSuccess,
  updateBrandingFail,
  resetBrandingChanges,
} from './branding.actions';

const transformUpdateParams = (values: IBrandingParams, logoId: number, bgId: number) => {
  const fieldValues: IBrandingColorParams = pickAll(
    [
      'backgroundColor',
      'tertiaryColor',
      'primaryColor',
      'secondaryColor',
      'highlightColor',
      'headlineColor',
      'primaryCtaColor',
      'secondaryCtaColor',
      'messageHeader',
      'backgroundSize',
      'privacyPolicyLink',
      'contactSupportLink',
      'companyName',
      'disclaimer',
      'giftCardConfirmationMessaging',
    ],
    values,
  );
  const { logoUrl, backgroundImageUrl, termsUrl } = values;
  return {
    ...fieldValues,
    logoId: logoId !== 0 && logoUrl !== null ? logoId : null,
    backgroundImageId: bgId !== 0 && backgroundImageUrl ? bgId : null,
    termsUrl: termsUrl === '' ? null : termsUrl,
  };
};

export const uploadImageEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(uploadImageRequest),
    switchMap(({ payload: { name, file } }) => {
      const formData = new FormData();
      formData.append('data', file, file.name);
      return apiService.postFile('/api/v1/branding/image', { body: formData }).pipe(
        mergeMap(({ data }: { data: { id: number; url: string } }) => {
          const { id, url } = data;
          return [uploadImageSuccess({ name, id, url }), applyBrandingImages({ name, image: { id, url } })];
        }),
        catchError(apiService.handleError(handlers.handleAnyError(uploadImageFail))),
      );
    }),
  );

export const updateBrandingEpic: Epic = (action$, state$, { apiService, messagesService }) =>
  action$.pipe(
    ofType(updateBrandingRequest),
    switchMap(({ payload }) =>
      apiService
        .put('/api/v1/branding', { body: transformUpdateParams(payload.values, payload.logoId, payload.bgId) })
        .pipe(
          mergeMap(({ data }: { data: IBranding }) => [
            updateBrandingSuccess(data),
            resetBrandingChanges(data),
            messagesService.showGlobalMessage({
              type: 'success',
              text: `Success! Your styling changes will be applied to landing pages for ${payload.brandingOwner}`,
            }),
          ]),
          catchError(apiService.handleError(handlers.handleAnyError(updateBrandingFail))),
        ),
    ),
  );

export const brandingEpics = [uploadImageEpic, updateBrandingEpic];
